import { render, staticRenderFns } from "./BtnCanal.vue?vue&type=template&id=6df7ac1c&"
import script from "./BtnCanal.vue?vue&type=script&lang=js&"
export * from "./BtnCanal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports